// Drizzle schema for the Phase 2 review-queue exclusions table.
//
// Split out of `./schema.ts` so the primary tables file stays under
// the 500-line policy cap (lint:max-lines). Re-exported from
// `@citycare/shared` via index.ts so the canonical import path is
// unchanged for consumers.
//
// `room_type_asset_exclusions` — Phase 2 "Don't track for this room
// type" action. Pre-emptively excludes a (room_type, asset_type)
// pair from the pairing-review queue and from the field-side Add
// Asset dialog for that room type. Forward-looking only — existing
// capture rows stay (Reject is what deletes them).
//
// Cascade: cascade on room_type drop (the exclusion is meaningless
// without the room type); restrict on asset_type drop so the
// classification UI cannot delete a type that still has live
// exclusions referencing it.

import { index, pgTable, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core'

import { assetTypes, roomTypes, users } from './schema'

export const roomTypeAssetExclusions = pgTable(
  'room_type_asset_exclusions',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    roomTypeId: uuid('room_type_id')
      .notNull()
      .references(() => roomTypes.id, { onDelete: 'cascade' }),
    assetTypeId: uuid('asset_type_id')
      .notNull()
      .references(() => assetTypes.id, { onDelete: 'restrict' }),
    dismissedAt: timestamp('dismissed_at', { withTimezone: true })
      .notNull()
      .defaultNow(),
    dismissedBy: uuid('dismissed_by')
      .notNull()
      .references(() => users.id, { onDelete: 'restrict' }),
  },
  (t) => ({
    uniquePair: uniqueIndex(
      'room_type_asset_exclusions_room_type_asset_unique',
    ).on(t.roomTypeId, t.assetTypeId),
    roomTypeIdx: index(
      'room_type_asset_exclusions_room_type_id_idx',
    ).on(t.roomTypeId),
    assetTypeIdx: index(
      'room_type_asset_exclusions_asset_type_id_idx',
    ).on(t.assetTypeId),
  }),
)
